@if (template(); as template) {
  <procure-entity-badge
    matTooltip="This entity was created from a template."
    [label]="template"
  />
}
@if (priorityLabel(); as label) {
  <procure-badge [label]="label" />
}
@if (additionalStatus(); as additionalStatus) {
  <procure-badge [label]="additionalStatus" />
}
@if (status(); as status) {
  <procure-status-badge [status]="status" />
}
